module.exports = __webpack_public_path__ + "img/product.dd08b861.png";